<template>
	<section class="mb-12 text-center">
		<h1
			class="font-weight-light mb-2"
			style="color: #3c4858; font-size: 24px"
			v-text="`${heading}`"
		/>

		<span
			v-if="role == 'admin'"
			class="font-weight-light"
			style="font-size: 16px; color: #3c4858"
		>
			{{ negocio ? negocio.nombre : "" }}
			{{ restGestObj && restGestObj.nombre ? " - " + restGestObj.nombre : "" }}
		</span>
		<span
			v-if="role == 'boss_negocio'"
			class="font-weight-light"
			style="font-size: 16px; color: #3c4858"
		>
			Negocio
			<a
				@click="goPanel"
				rel="noopener"
				target="_blank"
				class="secondary--text"
				style="text-decoration: none"
				>{{ negocio ? negocio.nombre : "" }}</a
			>
		</span>
	</section>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { goPanel } from "@/utils/router.js";
export default {
	name: "VComponent",

	props: {
		heading: {
			type: String,
			default: "",
		},
		link: {
			type: String,
			default: "",
		},
	},
	computed: {
		...mapGetters({
			role: "auth/role",
			restGestObj: "app/restGestObj",
		}),
		...mapState({
			negocio: (state) => state.app.negocioObjGest,
		}),
	},
	methods: {
		goPanel() {
			this.$router.push(goPanel());
		},
	},
};
</script>
